export const contentTableConfig = {
  title: '抢先机概念板块管理',
  propList: [
    {
      prop: 'stockTag',
      label: '概念名称',
      minWidth: '80'
    },
    {
      prop: 'content',
      label: '描述信息',
      minWidth: '120',
    },
    {
      prop: 'updateTime',
      label: '更新时间',
      minWidth: '100',
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/stockTag/dataImport'
}
